<template>
  <div class="container">
    <div class="title">
      <img src="../../src/assets/images/studio/logo.png" alt="" />
    </div>
    <div class="headerBac"></div>

    <div class="contentBox gzsbox">
      <div class="top">
        <div class="title">王阶全国名老中医工作室简介</div>
        <div class="pretitle">发布时间：{{obj.showTime}} 阅读量：{{obj.readCount}}</div>
      </div>
      <img :src="obj.illustration" alt="" />
      <div class="textDiv"  v-html="obj.details"></div>
    </div>
    <div class="footBac"></div>

  </div>
</template>
<script>
import API from '../../apis/index'

export default {
  name: "Studio",
  components: {
    // CarouselCopy,
  },
  data() {
    return {
      obj: {}
    };
  },
  mounted () {
    const currentRouter = {
        name: '工作室介绍',
        path: '/studio'
    }
    
    localStorage.setItem('currentRouter', JSON.stringify(currentRouter));
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.$http.get(`${API.getForum}?type=1&fId=13`).then(res => {
        console.log(res.data.data)
        this.obj = res.data.data
      })
    }
  }
};
</script>
<style scoped>
.container {
  width: 1000px;
  padding: 0 0 90px;
}
.headerBac{
    width: 100%;
    height: 60px;
    background: url("../../src/assets/images/headerBac.png") no-repeat;
    background-size: 100% 100%;
    margin-top: 20px;

}
.footBac{
    width: 100%;
    height: 60px;
    background: url("../../src/assets/images/footBac.png") no-repeat;
    background-size: 100% 100%;

}
.contentBox {
    width: 100%;
    /* height: 1098px; */
    background: url("../../src/assets/images/bodyBac.png") no-repeat;
    background-size: 100% 100%;
}

.gzsbox {
  display: flex;
  flex-direction: column;
  /* justify-content: space-between;
  align-items: center; */
  padding: 40px 45px;
}
.top {
  height: 70px;
  border-bottom: 1px solid #eae0d5;
}
.title {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #391603;
  line-height: 22px;
  margin-bottom: 10px;
}
.pretitle {
  font-size: 12px;
  font-family: PingFangTC-Regular, PingFangTC;
  font-weight: 400;
  color: #391603;
  line-height: 17px;
}
.gzsbox img {
  width: 400px;
  margin: 32px auto;
}
.textDiv{
  text-align: justify;
}
.text {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #553827;
  line-height: 24px;
}
</style>